import { p as promiseResolve, b as bootstrapLazy } from './index-4f4c2075.js';

/*
 Stencil Client Patch Esm v2.5.2 | MIT Licensed | https://stenciljs.com
 */
var patchEsm = function patchEsm() {
  return promiseResolve();
};
var defineCustomElements = function defineCustomElements(win, options) {
  if (typeof window === 'undefined') return Promise.resolve();
  return patchEsm().then(function () {
    return bootstrapLazy([["deckgo-slide-poll", [[1, "deckgo-slide-poll", {
      "socketUrl": [513, "socket-url"],
      "socketPath": [513, "socket-path"],
      "connectPollSocket": [4, "connect-poll-socket"],
      "pollLink": [513, "poll-link"],
      "pollKey": [1537, "poll-key"],
      "customBackground": [516, "custom-background"],
      "customActions": [516, "custom-actions"],
      "chartWidth": [32],
      "chartHeight": [32],
      "chartData": [32],
      "answeredOnce": [32],
      "beforeSwipe": [64],
      "afterSwipe": [64],
      "lazyLoadContent": [64],
      "revealContent": [64],
      "hideContent": [64],
      "resizeContent": [64],
      "update": [64],
      "isAnswered": [64]
    }]]]], options);
  });
};
export { defineCustomElements };